export const MIN_INFERENCES_SAMPLE = 10;

/** Number of inferred frames to sample for the Improve flow (higher for better training data) */
export const IMPROVE_INFERENCES_SAMPLE = 30;
